/* $(window).on('load', function () {
    var elementBHeight = $(".content-container").height() + $("#header-wrapper").height() + 6 - 80;
    $("#menu-overlay").css("height", elementBHeight + 100);
});
*/

export const menuExpander = document.getElementById('menu-expander');
export const menuExpanderWrapper = document.getElementById('menu-expander-wrapper');
export const menuOverlay = document.getElementById('menu-overlay');
export const menuSpacer = document.getElementById('menu-expander-spacer');

export const menuExpanderVyrtych = document.getElementById('menu-expander-vyrtych');
export const menuExpanderProdukty = document.getElementById('menu-expander-produkty');
export const menuExpanderSektory = document.getElementById('menu-expander-sektory');

export const menuItemVyrtych = document.getElementsByClassName('menu-item-vyrtych');
export const menuItemProdukty = document.getElementsByClassName('menu-item-produkty');
export const menuItemSektory = document.getElementsByClassName('menu-item-sektory');

export function showMenuExpander() {
    menuExpander.style.display = 'block';
    menuExpander.style.opacity = '1';
    menuExpanderWrapper.style.display = 'block';
    menuExpanderWrapper.style.opacity = '1';
    menuSpacer.style.display = 'block';
    menuSpacer.style.opacity = '1';
    menuOverlay.style.display = 'flex';
    menuOverlay.style.opacity = '0.24';
}

export function hideMenuExpander() {
    menuExpander.style.display = 'none';
    menuExpander.style.opacity = '0';
    menuExpanderWrapper.style.display = 'none';
    menuExpanderWrapper.style.opacity = '0';
    menuOverlay.style.display = 'none';
    menuOverlay.style.opacity = '0';
    hideMenuContentVyrtych();
    hideMenuContentProdukty();
    hideMenuContentSektory();
}

export function hideMenuExpanderSpacer() {
    menuSpacer.style.display = 'none';
    menuSpacer.style.opacity = '0';
}


export function showMenuContentVyrtych() {
    menuExpanderVyrtych.style.display = 'flex';
    for (let i = 0; i < menuItemVyrtych.length; i++) {
        let menuItemAnchor = menuItemVyrtych[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '#E02937';
        }
    }
}

export function showMenuContentProdukty() {
    menuExpanderProdukty.style.display = 'flex';
    for (let i = 0; i < menuItemProdukty.length; i++) {
        let menuItemAnchor = menuItemProdukty[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '#E02937';
        }
    }
}

export function showMenuContentSektory() {
    menuExpanderSektory.style.display = 'flex';
    for (let i = 0; i < menuItemSektory.length; i++) {
        let menuItemAnchor = menuItemSektory[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '#E02937';
        }
    }
}

export function hideMenuContentVyrtych() {
    menuExpanderVyrtych.style.display = 'none';
    for (let i = 0; i < menuItemVyrtych.length; i++) {
        let menuItemAnchor = menuItemVyrtych[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '';
        }
    }
}

export function hideMenuContentProdukty() {
    menuExpanderProdukty.style.display = 'none';
    for (let i = 0; i < menuItemProdukty.length; i++) {
        let menuItemAnchor = menuItemProdukty[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '';
        }
    }
}

export function hideMenuContentSektory() {
    menuExpanderSektory.style.display = 'none';
    for (let i = 0; i < menuItemSektory.length; i++) {
        let menuItemAnchor = menuItemSektory[i].querySelector('a');
        if (menuItemAnchor) {
            menuItemAnchor.style.color = '';
        }
    }
}






export function hideMenuContent() {
    menuExpanderVyrtych.style.display = 'none';
    menuExpanderProdukty.style.display = 'none';
    menuExpanderSektory.style.display = 'none';
}